"use strict";

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _wheel2Logic = require("../wheel2Logic");
var _Wheel2Disc = _interopRequireDefault(require("./Wheel2Disc"));
var _wheel2Sync = require("../wheel2Sync");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
// "Roue 2": a configurable wheel that decides the prize on the device itself (see wheel2Logic.js),
// so playing never needs the network. Counters live in localStorage; each play is queued and pushed
// to the back (wheel2Sync.js) whenever the device is online, which lets the admin follow the stocks.
// Everything (layout, options, texts, form, draw mode) comes from the cell `config`.
var START_DELAY_MS = 4000;
var KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'C', '0', 'B'];
var EMAIL_RE = /^[\w.+-]+@([\w-]+\.)+[\w-]{2,}$/;
var Wheel2Cell = function Wheel2Cell(props) {
  var cell = props.cell,
    _props$uriTransformer = props.uriTransformer,
    uriTransformer = _props$uriTransformer === void 0 ? function (u) {
      return u;
    } : _props$uriTransformer,
    page = props.page,
    preview = props.preview,
    project = props.project;
  var config = (0, _react.useMemo)(function () {
    return (0, _wheel2Logic.parseConfig)(cell.config);
  }, [cell.config]);
  var layout = config.layout,
    options = config.options,
    texts = config.texts,
    stage = config.stage;
  var accent = cell.accent_color || '#c20e1a';
  var backEndUri = project && project.backEndUri;
  var img = function img(u) {
    return u ? uriTransformer(u) : null;
  };
  var containerRef = (0, _react.useRef)(null);
  var _ref = (0, _react.useState)({
      w: 0,
      h: 0
    }),
    _ref2 = _slicedToArray(_ref, 2),
    box = _ref2[0],
    setBox = _ref2[1];
  var _ref3 = (0, _react.useState)(''),
    _ref4 = _slicedToArray(_ref3, 2),
    code = _ref4[0],
    setCode = _ref4[1];
  var _ref5 = (0, _react.useState)({}),
    _ref6 = _slicedToArray(_ref5, 2),
    player = _ref6[0],
    setPlayer = _ref6[1];
  var _ref7 = (0, _react.useState)(''),
    _ref8 = _slicedToArray(_ref7, 2),
    message = _ref8[0],
    setMessage = _ref8[1];
  var _ref9 = (0, _react.useState)('idle'),
    _ref0 = _slicedToArray(_ref9, 2),
    phase = _ref0[0],
    setPhase = _ref0[1]; // idle | spinning | result
  var _ref1 = (0, _react.useState)(''),
    _ref10 = _slicedToArray(_ref1, 2),
    timerText = _ref10[0],
    setTimerText = _ref10[1];
  var _ref11 = (0, _react.useState)(0),
    _ref12 = _slicedToArray(_ref11, 2),
    rotation = _ref12[0],
    setRotation = _ref12[1];
  var _ref13 = (0, _react.useState)(false),
    _ref14 = _slicedToArray(_ref13, 2),
    spinning = _ref14[0],
    setSpinning = _ref14[1];
  var _ref15 = (0, _react.useState)(null),
    _ref16 = _slicedToArray(_ref15, 2),
    result = _ref16[0],
    setResult = _ref16[1];
  var _ref17 = (0, _react.useState)('play'),
    _ref18 = _slicedToArray(_ref17, 2),
    mode = _ref18[0],
    setMode = _ref18[1]; // play | admin (asks the code before the stock panel)
  var _ref19 = (0, _react.useState)(false),
    _ref20 = _slicedToArray(_ref19, 2),
    adminOpen = _ref20[0],
    setAdminOpen = _ref20[1];
  var _ref21 = (0, _react.useState)(0),
    _ref22 = _slicedToArray(_ref21, 2),
    bump = _ref22[1];
  var timers = (0, _react.useRef)([]);
  var tapsRef = (0, _react.useRef)([]);
  var memState = (0, _react.useRef)(null);
  var key = (0, _wheel2Sync.storageKey)(cell.id, config);
  // The admin preview must never touch the real counters of the device.
  var getState = function getState() {
    return preview ? memState.current = memState.current || (0, _wheel2Logic.emptyState)() : (0, _wheel2Sync.loadState)(key);
  };
  var putState = function putState(s) {
    if (preview) memState.current = s;else (0, _wheel2Sync.saveState)(key, s);
  };
  var later = function later(fn, ms) {
    timers.current.push(setTimeout(fn, ms));
  };
  (0, _react.useEffect)(function () {
    return function () {
      return timers.current.forEach(clearTimeout);
    };
  }, []);

  // Sync in the background: at start, when the network comes back, and every minute.
  (0, _react.useEffect)(function () {
    if (preview) return undefined;
    var run = function run() {
      return (0, _wheel2Sync.syncWheel2)({
        backEndUri: backEndUri,
        cellId: cell.id,
        config: config
      }).then(function () {
        return bump(function (n) {
          return n + 1;
        });
      });
    };
    run();
    var id = setInterval(run, 60000);
    window.addEventListener('online', run);
    return function () {
      clearInterval(id);
      window.removeEventListener('online', run);
    };
  }, [backEndUri, cell.id, config.stockVersion, config.testMode, config.shareStock, preview]); // eslint-disable-line react-hooks/exhaustive-deps

  var setContainer = (0, _react.useCallback)(function (el) {
    if (containerRef.current && containerRef.current.__ro) containerRef.current.__ro.disconnect();
    containerRef.current = el;
    if (el && typeof ResizeObserver !== 'undefined') {
      var update = function update() {
        return setBox({
          w: el.clientWidth,
          h: el.clientHeight
        });
      };
      el.__ro = new ResizeObserver(update);
      el.__ro.observe(el);
      update();
    }
  }, []);
  var SW = Number(stage.width) || 1080;
  var SH = Number(stage.height) || 1920;
  var scale = (0, _utils.fitScale)(box.w, box.h, SW, SH);
  var press = function press(k) {
    setMessage('');
    if (k === 'C') setCode('');else if (k === 'B') setCode(function (c) {
      return c.slice(0, -1);
    });else setCode(function (c) {
      return c.length < 8 ? c + k : c;
    });
  };
  var codeOk = function codeOk() {
    return !config.code || String(code) === String(config.code);
  };
  var formFields = config.form.enabled ? config.form.fields : [];
  var formValid = function formValid() {
    return formFields.every(function (f) {
      var v = player[f.name];
      if (f.required && (v === undefined || v === '' || v === false)) return false;
      if (f.type === 'email' && v && !EMAIL_RE.test(v)) return false;
      return true;
    });
  };
  var reset = function reset() {
    setSpinning(false);
    setRotation(0);
    setCode('');
    setPlayer({});
    setMessage('');
    setResult(null);
    setTimerText('');
    setPhase('idle');
  };
  var play = function play() {
    if (phase !== 'idle') return;
    if (config.paused) {
      setMessage(texts.paused);
      return;
    }
    if (!config.segments.length) {
      setMessage(texts.notConfigured);
      return;
    }
    if (!formValid()) {
      setMessage(texts.missingFields);
      return;
    }
    if (config.code && !code) {
      setMessage(texts.needCode);
      return;
    }
    if (!codeOk()) {
      setMessage(texts.wrongCode);
      return;
    }
    var state = getState();
    var _ref23 = (0, _wheel2Logic.spin)(config, state, new Date(), Math.random, formFields.length ? player : null),
      prize = _ref23.prize,
      angle = _ref23.angle;
    putState(state);
    var startDelay = options.countdown ? START_DELAY_MS : 300;
    var spinMs = (Number(options.spinSeconds) || 17) * 1000;
    setPhase('spinning');
    setResult(prize);
    setTimerText('');
    if (options.countdown) {
      [['3', 1000], ['2', 2000], ['1', 3000], ['GO!', 4000], ['', 5000]].forEach(function (_ref24) {
        var _ref25 = _slicedToArray(_ref24, 2),
          t = _ref25[0],
          ms = _ref25[1];
        return later(function () {
          return setTimerText(t);
        }, ms);
      });
    }
    if (options.sound && cell.sound_uri) {
      later(function () {
        try {
          var a = new Audio(img(cell.sound_uri));
          var p = a.play();
          if (p && p.catch) p.catch(function () {});
        } catch (e) {/* no audio */}
      }, Math.max(startDelay - 1000, 0));
    }
    later(function () {
      setSpinning(true);
      setRotation(angle);
    }, startDelay);
    var endAt = startDelay + spinMs + 1500;
    if (options.showResult) {
      later(function () {
        return setPhase('result');
      }, endAt);
      later(function () {
        reset();
        syncNow();
      }, endAt + (Number(options.resultSeconds) || 15) * 1000);
    } else {
      later(function () {
        reset();
        syncNow();
      }, endAt + 1000);
    }
  };
  var syncNow = function syncNow() {
    if (!preview) (0, _wheel2Sync.syncWheel2)({
      backEndUri: backEndUri,
      cellId: cell.id,
      config: config
    }).then(function () {
      return bump(function (n) {
        return n + 1;
      });
    });
  };
  var confirm = function confirm() {
    if (mode === 'admin') {
      if (codeOk() && code) {
        setAdminOpen(true);
        setMode('play');
        setCode('');
        setMessage('');
      } else setMessage(texts.wrongCode);
      return;
    }
    play();
  };

  // 5 quick taps on the title area -> stock panel of this device (asks the code first).
  var onTitleTap = function onTitleTap() {
    var now = Date.now();
    tapsRef.current = tapsRef.current.filter(function (t) {
      return now - t < 3000;
    }).concat(now);
    if (tapsRef.current.length >= 5 && phase === 'idle' && config.code) {
      tapsRef.current = [];
      setMode('admin');
      setCode('');
      setMessage('Entrez le code puis confirmez.');
    }
  };
  var state = getState();
  var remaining = (0, _wheel2Logic.remainingStock)(config, state);
  var given = (0, _wheel2Logic.effectiveGiven)(config, state);
  var pendingCount = (state.pending || []).filter(function (p) {
    return !p.test;
  }).length;
  var todayWon = (state.days[(0, _wheel2Logic.dateKey)(new Date())] || {}).won || 0;
  var prize = result ? config.prizes[result] : null;
  var resetCounters = function resetCounters() {
    if (!window.confirm('Remettre à zéro les compteurs de cet appareil ?')) return;
    putState((0, _wheel2Logic.emptyState)());
    bump(function (n) {
      return n + 1;
    });
  };
  var abs = function abs(style) {
    return _objectSpread({
      position: 'absolute'
    }, style);
  };
  var btn = {
    height: 92,
    borderRadius: 20,
    background: options.panelBackground,
    color: accent,
    border: "3px solid ".concat(accent),
    fontFamily: 'inherit'
  };
  var needsKeypad = !!config.code || mode === 'admin';
  var showPanel = phase === 'idle' && !adminOpen;
  var t = layout.title;
  var drawn = config.wheel.source === 'generated';
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: setContainer,
    style: _objectSpread({
      position: 'relative',
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      userSelect: 'none'
    }, props.style)
  }, /*#__PURE__*/_react.default.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n        @keyframes w2tick { from { transform: scale(1.2); opacity: .2 } to { transform: scale(1); opacity: 1 } }\n        @keyframes w2idle { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }\n        .w2-".concat(cell.id, " button { touch-action: manipulation; }\n        .w2-").concat(cell.id, " .w2-key:active, .w2-").concat(cell.id, " .w2-ok:active { background: ").concat(accent, " !important; color: #fff !important; }\n        .w2-").concat(cell.id, " input[type=text], .w2-").concat(cell.id, " input[type=email], .w2-").concat(cell.id, " input[type=tel],\n        .w2-").concat(cell.id, " input[type=number], .w2-").concat(cell.id, " select { width: 100%; box-sizing: border-box; font: inherit; font-size: 34px;\n          padding: 14px; margin: 6px 0 14px; border: 2px solid ").concat(accent, "; border-radius: 16px; color: ").concat(accent, "; background: #fff; }\n      ")
    }
  }), scale > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "w2-".concat(cell.id),
    style: {
      position: 'absolute',
      left: (box.w - SW * scale) / 2,
      top: (box.h - SH * scale) / 2,
      width: SW,
      height: SH,
      transform: "scale(".concat(scale, ")"),
      transformOrigin: '0 0',
      overflow: 'hidden',
      color: accent,
      background: cell.background_uri ? "url(\"".concat(img(cell.background_uri), "\") 0 0 / ").concat(SW, "px ").concat(SH, "px no-repeat") : 'transparent'
    }
  }, t.show && cell.title_text && /*#__PURE__*/_react.default.createElement("div", {
    onClick: onTitleTap,
    style: abs({
      left: t.x,
      top: t.y,
      width: t.w,
      height: t.h,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: t.color,
      fontSize: t.size,
      whiteSpace: 'nowrap',
      zIndex: 5
    })
  }, cell.title_text), !(t.show && cell.title_text) && /*#__PURE__*/_react.default.createElement("div", {
    onClick: onTitleTap,
    style: abs({
      left: 0,
      top: 0,
      width: 200,
      height: 120,
      zIndex: 5
    })
  }), (drawn || cell.wheel_uri) && function () {
    var wheelStyle = abs(_objectSpread({
      left: layout.wheel.x,
      top: layout.wheel.y,
      width: layout.wheel.size
    }, phase === 'idle' && options.idleSpin ? {
      animation: "w2idle ".concat(options.idleSpinSeconds || 10, "s linear infinite")
    } : {
      transform: "rotate(".concat(rotation, "deg)"),
      transition: spinning ? "transform ".concat(Number(options.spinSeconds) || 17, "s cubic-bezier(.12,.6,.1,1)") : 'none'
    }));
    return drawn ? /*#__PURE__*/_react.default.createElement(_Wheel2Disc.default, {
      config: config,
      uriTransformer: uriTransformer,
      style: _objectSpread(_objectSpread({}, wheelStyle), {}, {
        height: layout.wheel.size
      })
    }) : /*#__PURE__*/_react.default.createElement("img", {
      alt: "",
      src: img(cell.wheel_uri),
      draggable: false,
      style: wheelStyle
    });
  }(), layout.arrow.show && !cell.arrow_uri && drawn && /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 100 120",
    style: abs({
      left: layout.arrow.x,
      top: layout.arrow.y,
      width: layout.arrow.size,
      zIndex: 90
    })
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M50 118 L8 10 Q50 -6 92 10 Z",
    fill: accent,
    stroke: "#fff",
    strokeWidth: "6",
    strokeLinejoin: "round"
  })), layout.arrow.show && cell.arrow_uri && /*#__PURE__*/_react.default.createElement("img", {
    alt: "",
    src: img(cell.arrow_uri),
    draggable: false,
    style: abs({
      left: layout.arrow.x,
      top: layout.arrow.y,
      width: layout.arrow.size,
      zIndex: 90
    })
  }), timerText !== '' && /*#__PURE__*/_react.default.createElement("div", {
    key: timerText,
    style: abs({
      left: 0,
      top: layout.timer.y,
      width: SW,
      height: 400,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: timerText === 'GO!' ? layout.timer.size * 0.6 : layout.timer.size,
      lineHeight: 1,
      zIndex: 120,
      pointerEvents: 'none',
      textShadow: '0 0 24px #fff, 0 0 8px #fff',
      animation: 'w2tick .35s ease-out'
    })
  }, timerText), showPanel && /*#__PURE__*/_react.default.createElement("div", {
    style: abs({
      left: layout.form.x,
      top: layout.form.y,
      width: layout.form.w,
      boxSizing: 'border-box',
      padding: '26px 30px 20px',
      background: options.panelBackground,
      border: "4px solid ".concat(accent),
      borderRadius: 40,
      textAlign: 'center',
      zIndex: 100,
      fontSize: 44,
      maxHeight: SH - layout.form.y - 20,
      overflowY: 'auto'
    })
  }, /*#__PURE__*/_react.default.createElement("div", null, mode === 'admin' ? texts.admin : formFields.length ? config.form.title : texts.launch), mode === 'play' && formFields.map(function (f) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: f.name,
      style: {
        textAlign: 'left',
        fontSize: 30,
        marginTop: 8
      }
    }, f.type === 'checkbox' ? /*#__PURE__*/_react.default.createElement("label", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        margin: '12px 0'
      }
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "checkbox",
      style: {
        width: 36,
        height: 36
      },
      checked: !!player[f.name],
      onChange: function onChange(e) {
        setMessage('');
        setPlayer(_objectSpread(_objectSpread({}, player), {}, _defineProperty({}, f.name, e.target.checked)));
      }
    }), /*#__PURE__*/_react.default.createElement("span", null, f.label, f.required ? ' *' : '')) : /*#__PURE__*/_react.default.createElement("label", null, f.label, f.required ? ' *' : '', f.type === 'select' ? /*#__PURE__*/_react.default.createElement("select", {
      value: player[f.name] || '',
      onChange: function onChange(e) {
        setMessage('');
        setPlayer(_objectSpread(_objectSpread({}, player), {}, _defineProperty({}, f.name, e.target.value)));
      }
    }, /*#__PURE__*/_react.default.createElement("option", {
      value: ""
    }), (f.options || []).map(function (o) {
      return /*#__PURE__*/_react.default.createElement("option", {
        key: o,
        value: o
      }, o);
    })) : /*#__PURE__*/_react.default.createElement("input", {
      type: f.type || 'text',
      value: player[f.name] || '',
      onChange: function onChange(e) {
        setMessage('');
        setPlayer(_objectSpread(_objectSpread({}, player), {}, _defineProperty({}, f.name, e.target.value)));
      }
    })));
  }), needsKeypad && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      margin: '10px auto 0',
      width: '90%',
      height: 92,
      lineHeight: '92px',
      fontSize: 64,
      letterSpacing: 14,
      border: "2px solid ".concat(accent),
      borderRadius: 20,
      boxSizing: 'border-box'
    }
  }, code ? '•'.repeat(code.length) : /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontSize: 44,
      letterSpacing: 0,
      opacity: .6
    }
  }, texts.codeLabel)), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 12,
      width: '90%',
      margin: '18px auto 4px'
    }
  }, KEYS.map(function (k) {
    return /*#__PURE__*/_react.default.createElement("button", {
      key: k,
      type: "button",
      className: "w2-key",
      onClick: function onClick() {
        return press(k);
      },
      style: _objectSpread(_objectSpread({}, btn), {}, {
        fontSize: k === 'C' || k === 'B' ? 34 : 54
      })
    }, k === 'C' ? 'Effacer' : k === 'B' ? '←' : k);
  }))), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "w2-ok",
    onClick: confirm,
    style: _objectSpread(_objectSpread({}, btn), {}, {
      width: '90%',
      fontSize: 44,
      marginTop: 12
    })
  }, mode === 'admin' ? 'Ouvrir' : config.code ? texts.confirm : texts.play), mode === 'admin' && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: function onClick() {
      setMode('play');
      setMessage('');
      setCode('');
    },
    style: {
      marginTop: 12,
      fontSize: 30,
      background: 'none',
      border: 0,
      color: accent,
      fontFamily: 'inherit'
    }
  }, "Annuler"), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: 28,
      minHeight: 36,
      marginTop: 10
    }
  }, message)), adminOpen && /*#__PURE__*/_react.default.createElement("div", {
    style: abs({
      left: layout.result.x,
      top: layout.result.y,
      width: layout.result.w,
      boxSizing: 'border-box',
      padding: 40,
      background: options.panelBackground,
      border: "6px solid ".concat(accent),
      borderRadius: 40,
      zIndex: 200,
      fontSize: 36,
      textAlign: 'left'
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: 52,
      textAlign: 'center',
      marginBottom: 20
    }
  }, "Stocks", config.testMode ? ' (mode essai)' : ''), Object.keys(config.prizes).map(function (k) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: k,
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '10px 0'
      }
    }, /*#__PURE__*/_react.default.createElement("span", null, config.prizes[k].label || k), /*#__PURE__*/_react.default.createElement("span", null, given[k] || 0, " donn\xE9s \xB7 ", Math.max(remaining[k], 0), " restants"));
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: 20
    }
  }, "Parties sur cet appareil : ", state.events.length, " \xB7 gagnantes aujourd'hui : ", todayWon), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: 28,
      opacity: .7,
      marginTop: 6
    }
  }, pendingCount ? "".concat(pendingCount, " partie(s) \xE0 envoyer (r\xE9seau)") : 'Tout est synchronisé'), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      gap: 20,
      marginTop: 30
    }
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: resetCounters,
    style: _objectSpread(_objectSpread({}, btn), {}, {
      flex: 1,
      height: 84,
      fontSize: 32
    })
  }, "Remise \xE0 z\xE9ro"), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setAdminOpen(false);
    },
    style: {
      flex: 1,
      height: 84,
      fontSize: 32,
      borderRadius: 20,
      background: accent,
      color: '#fff',
      border: 0,
      fontFamily: 'inherit'
    }
  }, "Fermer"))), phase === 'result' && /*#__PURE__*/_react.default.createElement("div", {
    style: abs({
      left: layout.result.x,
      top: layout.result.y,
      width: layout.result.w,
      boxSizing: 'border-box',
      background: options.panelBackground,
      border: "6px solid ".concat(accent),
      borderRadius: 60,
      padding: '50px 40px',
      textAlign: 'center',
      zIndex: 150
    })
  }, prize ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: 96,
      marginBottom: 10
    }
  }, texts.win), prize.image_uri ? /*#__PURE__*/_react.default.createElement("img", {
    alt: prize.label,
    src: img(prize.image_uri),
    style: {
      width: '100%',
      borderRadius: 24,
      margin: '20px 0'
    }
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: 56,
      margin: '10px 0'
    }
  }, prize.label), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      gap: 30,
      justifyContent: 'center',
      alignItems: 'center',
      margin: '20px 0'
    }
  }, (prize.logo_uris || []).map(function (u) {
    return /*#__PURE__*/_react.default.createElement("img", {
      key: u,
      alt: "",
      src: img(u),
      style: {
        maxHeight: 380,
        maxWidth: '45%',
        objectFit: 'contain'
      }
    });
  })), prize.partner && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: 36
    }
  }, prize.partner))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: 96,
      marginBottom: 10
    }
  }, texts.lose), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: 56,
      margin: '10px 0'
    }
  }, texts.loseSub), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: 36
    }
  }, texts.thanks)))));
};
var _default = exports.default = Wheel2Cell;